<div class="dialog-container">
  <div class="dialog-header">
    <h2>Reprocess Referral</h2>
    <div>{{referral?.memberMedicaidId}} - {{referral?.memberFirstName}} {{referral?.memberLastName}}</div>    
  </div>
  <!-- Content Section -->
  <div class="dialog-content">
    <form [formGroup]="form">
      <!-- Reprocess Reason -->
      <mat-form-field appearance="fill">
        <mat-label>Reprocess Reason</mat-label>
        <mat-select [formControl]="reprocessReasonFormControl">
          <mat-option *ngFor="let reason of reprocessReasons" [value]="reason.name">
            {{reason.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="reprocessReasonFormControl.hasError('required')">Please choose a reason.</mat-error>
        <mat-hint></mat-hint>
      </mat-form-field>

      <!-- Additional Details -->
      <mat-form-field appearance="fill">
        <mat-label>Additional Details</mat-label>
        <textarea matInput id="reprocessAdditionalDetailsFormControl" formControlName="reprocessAdditionalDetailsFormControl"></textarea>
        <mat-error *ngIf="reprocessAdditionalDetailsFormControl.hasError('required')">Please enter any additional details that will help the reviewer when reprocessing this referral.</mat-error>
      </mat-form-field>
    </form>
  </div>

  <!-- Action Buttons -->
  <div class="dialog-actions">
    <button mat-button (click)="onClose()" class="close-button">Close</button>
    <button mat-raised-button color="primary" (click)="onSave()" class="save-button" [disabled]="form.invalid">Save</button>
  </div>
</div>
